<template>
  <v-container id="ur-list">
    <sala-municipio-header :payload="payload"> </sala-municipio-header>

    <v-row>
      <v-col
        ><h3><b>Custo</b></h3></v-col
      >
      <v-col class="text-right">
        <app-modal-insert
          v-if="isAdmin"
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadIndicadoresMunicipio"
        >
          <template v-slot:title :edit="false"> Cadastrar Custo </template>
        </app-modal-insert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <span>
              {{ item.nomeIndicador }}
            </span>
          </template>
          <template v-slot:item.nomeNivel="{ item }">
            <span v-html="item.nomeNivel"> </span>
          </template>
          <template v-slot:item.Serie="{ item }">
            <span v-html="item.Serie"> </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-insert
                  v-if="isAdmin"
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadIndicadoresMunicipio"
                >
                  <template v-slot:title> Editar Custo </template>
                </app-modal-insert>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row>
              <v-col cols="1">
                <app-modal-delete
                  v-if="isAdmin"
                  :object="item"
                  @on-save="loadIndicadoresMunicipio"
                >
                  <template v-slot:title> Deletar </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum Custo retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsert from "./ModalInsert";
import { SalaCustoAPI } from "../API/SalaCusto";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";
import SalaMunicipioHeader from "../../sala-principal/components/SalaMunicipioHeader";
import moment from "moment";
export default {
  components: {
    AppModalInsert,
    AppModalDelete,
    SalaMunicipioHeader,
  },
  data() {
    return {
      headers: [
        { text: "Custo", value: "custo", width: "150px" },
        { text: "Item", value: "item", width: "150px" },
        { text: "Data", value: "data", width: "150px" },
        { text: "Editar", value: "acoes", width: "150px", sortable: false },
        {
          text: "Excluir",
          value: "acoes_delete",
          width: "150px",
          sortable: false,
        },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadcustos() {
      this.setLoading(true);
      SalaCustoAPI.getbyMunicipio(this.$route.params.id)
        .then((resp) => {
          this.payload = resp.data.map((item) => {
            return {
              custo: item.custo,
              item: item.item,
              municipioId: item.municipioId,
              salaCustoId: item.salaCustoId,
              data: moment(item.data).format("DD/MM/YYYY"),
            };
          });

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Custos");
        });
    },
  },
  mounted() {
    this.loadcustos();
  },
  computed: {
    ...mapGetters(["isAdmin"]),
  },
};
</script>
